import React, { useState } from "react";
import {
  Modal,
  Button,
  Select,
  Row,
  Col,
  Card,
  Table,
  Tag,
  message,
} from "antd";
import { useEffect } from "react";
import { odata } from "../Filters/Helper";
import RequestHandler from "../../util/RequestHandler";

const { Option } = Select;

const currencyColors = {
  TRY: "green",
  USD: "blue",
  EUR: "purple",
};

const CompareQuotesModal = ({ visible, onClose }) => {
  const [purchaseRequests, setPurchaseRequests] = useState({
    data: [],
    loading: false,
  });
  const [selectedRequestId, setSelectedRequestId] = useState(null);
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {}, []);

  // 🎯 Backend çağrısı — örnek endpoint: /api/Quote/GetByPurchaseRequestId
  const fetchQuotesByRequest = async (requestId) => {
    try {
      if (!requestId) {
        return;
      }

      setLoading(true);
      const response = await RequestHandler.get(
        `/Quote/GetListQueryableOdataByPurchaseRequestId/${requestId}`
      );
      setQuotes(response);
      if (response?.length === 0) {
        message.info("Bu talebe ait teklif bulunamadı.");
      } else {
        message.success("Teklifler başarıyla yüklendi 🎉");
      }
    } catch (err) {
      message.error("Teklifler alınırken hata oluştu!");
    } finally {
      setLoading(false);
    }
  };

  // Teklifleri 3’lü gruplara ayır
  const groupedQuotes = [];
  for (let i = 0; i < quotes.length; i += 3) {
    groupedQuotes.push(quotes.slice(i, i + 3));
  }

  const currencies = [
    { id: 1, code: "TRY", symbol: "₺" },
    { id: 2, code: "USD", symbol: "$" },
    { id: 3, code: "EUR", symbol: "€" },
  ];

  const renderTotals = (quote) => {
    const rows = quote.quoteItems || [];

    // 🔹 İlk item’in currencyId’sini al
    const currencyId = rows?.[0]?.currencyId;

    // 🔹 currencies listesinden sembol bul
    const foundCurrency =
      currencies.find((c) => c.id === currencyId) ||
      currencies.find((c) => c.id === 1); // fallback TRY

    const symbol = foundCurrency.symbol;
    const color = currencyColors[foundCurrency.code || "TRY"];

    // 🔹 Hesaplamalar (aynı kalıyor)
    const malHizmetToplam = rows.reduce(
      (sum, r) => sum + (r.quantity || 0) * (r.unitPrice || 0),
      0
    );
    const toplamIskonto = rows.reduce((sum, r) => sum + (r.discount || 0), 0);
    const hesaplananKDV = rows.reduce((sum, r) => {
      const net = (r.quantity || 0) * (r.unitPrice || 0) - (r.discount || 0);
      return sum + net * ((r.vat || 0) / 100);
    }, 0);
    const vergilerDahilToplam = rows.reduce((sum, r) => {
      const net = (r.quantity || 0) * (r.unitPrice || 0) - (r.discount || 0);
      const total = net + net * ((r.vat || 0) / 100);
      return sum + total;
    }, 0);
    const toplamOdenecek = vergilerDahilToplam;

    // 🔹 Görsel kısım (önceki sürümden)
    const amountStyle = {
      display: "inline-block",
      minWidth: 140,
      textAlign: "right",
      fontSize: 16,
      fontWeight: 600,
      color: "#111",
      background: "linear-gradient(90deg, #fafafa, #f3f3f3)",
      borderRadius: 8,
      padding: "3px 8px",
      boxShadow: "inset 0 0 4px rgba(0,0,0,0.06)",
    };

    const highlightStyle = {
      ...amountStyle,
      fontSize: 18,
      background: `linear-gradient(90deg, ${color}, #ffffff)`,
      color: "#000",
      fontWeight: 700,
      boxShadow: "0 0 8px rgba(0,0,0,0.08)",
    };

    return (
      <div
        style={{
          borderTop: "1px solid #f0f0f0",
          marginTop: 12,
          paddingTop: 12,
          fontSize: 14,
          textAlign: "right",
          fontWeight: "bold",
          lineHeight: 1.6,
        }}
      >
        <div>
          Mal Hizmet Toplam Tutarı:{" "}
          <span style={amountStyle}>
            {symbol} {malHizmetToplam.toFixed(2)}
          </span>
        </div>
        <div>
          Toplam İskonto:{" "}
          <span style={amountStyle}>
            {symbol} {toplamIskonto.toFixed(2)}
          </span>
        </div>
        <div>
          Hesaplanan KDV:{" "}
          <span style={amountStyle}>
            {symbol} {hesaplananKDV.toFixed(2)}
          </span>
        </div>
        <div>
          Vergiler Dahil Toplam Tutar:{" "}
          <span style={amountStyle}>
            {symbol} {vergilerDahilToplam.toFixed(2)}
          </span>
        </div>
        <div style={{ marginTop: 10 }}>
          Toplam Ödenecek Tutar:{" "}
          <span style={highlightStyle}>
            {symbol} {toplamOdenecek.toFixed(2)}
          </span>
        </div>
      </div>
    );
  };

  const onPurchaseRequestSearch = (value) => {
    if (value.length >= 2) {
      setPurchaseRequests({ data: [], loading: true });

      RequestHandler.get(
        `/PurchaseRequest/GetListQueryableOdataForQuotesCompare?$filter=(${odata.contains(
          "name",
          value
        )} or ${odata.contains("description", value)})  and Name ne 'Diğer'`
      ).then((res) => {
        setPurchaseRequests({ data: res, loading: false });
      });
    } else {
      setPurchaseRequests({ data: [], loading: false });
    }
  };
  return (
    <Modal
      title="💼 Talebe Bağlı Teklifleri Karşılaştır"
      visible={visible}
      onCancel={onClose}
      width="90%"
      footer={null}
    >
      {/* 🔽 Talep Seçimi */}
      <div style={{ marginBottom: 16 }}>
        <Select
          allowClear
          showSearch
          placeholder="Talep seçiniz. En az 2 harf giriniz.."
          onSearch={onPurchaseRequestSearch}
          filterOption={(input, option) =>
            option?.children
              ?.toLocaleLowerCase("tr-TR")
              .includes(input.toLocaleLowerCase("tr-TR")) ||
            option?.name
              ?.toLocaleLowerCase("tr-TR")
              .includes(input.toLocaleLowerCase("tr-TR"))
          }
          loading={loading}
          onChange={(val) => {
            setSelectedRequestId(val);
            fetchQuotesByRequest(val);
          }}
          style={{ width: 400 }} // ✅ genişlik buraya!
        >
          {purchaseRequests?.data?.map((req) => (
            <Option key={req.id} value={req.id} name={req.name}>
              {req.name}
            </Option>
          ))}
        </Select>
      </div>

      {/* 🔄 Teklif kartları */}
      {groupedQuotes.map((group, idx) => (
        <Row gutter={16} key={idx} style={{ marginBottom: 24 }}>
          {group.map((quote) => {
            const currencyId = quote.quoteItems?.[0]?.currencyId;

            // 🔹 currencies listesinden sembol bul
            const foundCurrency =
              currencies.find((c) => c.id === currencyId) ||
              currencies.find((c) => c.id === 1);
            const symbol = foundCurrency.symbol;
            const color = currencyColors[foundCurrency.code || "TRY"];
            return (
              <Col span={8} key={quote.id}>
                <Card
                  title={
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span>{quote.supplierName || "Tedarikçi Adı Yok"}</span>
                      <Tag color={color}>{foundCurrency?.code || "TRY"}</Tag>
                    </div>
                  }
                  bordered
                  style={{ borderRadius: 12 }}
                >
                  <Table
                    pagination={false}
                    size="small"
                    rowKey="id"
                    columns={[
                      { title: "Malzeme", dataIndex: "name" },
                      { title: "Birim", dataIndex: "unit", align: "center" },
                      {
                        title: "Miktar",
                        dataIndex: "quantity",
                        align: "right",
                      },
                      {
                        title: "Birim Fiyat",
                        dataIndex: "unitPrice",
                        align: "right",
                        render: (val) => `${symbol || "₺"} ${val?.toFixed(2)}`,
                      },
                      {
                        title: "Toplam",
                        dataIndex: "total",
                        align: "right",
                        render: (_, r) => {
                          const total =
                            (r.quantity * r.unitPrice - r.discount) *
                            (1 + r.vat / 100);
                          return `${symbol || "₺"} ${total.toFixed(2)}`;
                        },
                      },
                    ]}
                    dataSource={quote.quoteItems}
                  />
                  {renderTotals(quote)}
                </Card>
              </Col>
            );
          })}
        </Row>
      ))}
    </Modal>
  );
};

export default CompareQuotesModal;
